import type { FunctionComponent } from "react";

import type { ContainerProps } from "./styles";
import { Container, Placeholder, PlusPlaceholderImage } from "./styles";

type Props = ContainerProps;

export const ContentPlaceholder: FunctionComponent<Props> = ({ ...props }) => {
  const renderPlaceholder = () => {
    switch (props.$variant) {
      case "plus":
        return <PlusPlaceholderImage />;
      default:
        return <Placeholder />;
    }
  };
  return <Container {...props}>{renderPlaceholder()}</Container>;
};
ContentPlaceholder.displayName = "ContentPlaceholder";
